import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { MESI } from "@/lib/format";

const MESI_FULL = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

export const usePeriod = () => {
  const now = new Date();
  const [period, setPeriod] = useState({ year: now.getFullYear(), month: now.getMonth() + 1 });
  const prefix = period.month ? `${period.year}-${String(period.month).padStart(2, "0")}` : String(period.year);
  const inPeriod = (d) => (d || "").startsWith(prefix);
  const inYear = (d) => (d || "").startsWith(String(period.year));
  const label = period.month ? `${MESI_FULL[period.month - 1]} ${period.year}` : `Anno ${period.year}`;
  return { period, setPeriod, prefix, inPeriod, inYear, label };
};

export const periodRange = ({ year, month }) => {
  if (!month) return { defaultFrom: `${year}-01-01`, defaultTo: `${year}-12-31` };
  const mm = String(month).padStart(2, "0");
  const last = new Date(year, month, 0).getDate();
  return { defaultFrom: `${year}-${mm}-01`, defaultTo: `${year}-${mm}-${String(last).padStart(2, "0")}` };
};

export const PeriodPicker = ({ period, setPeriod, testPrefix = "period" }) => {
  const isMonth = !!period.month;
  const shift = (d) => {
    if (!isMonth) return setPeriod({ ...period, year: period.year + d });
    let m = period.month + d, y = period.year;
    if (m < 1) { m = 12; y -= 1; }
    if (m > 12) { m = 1; y += 1; }
    setPeriod({ year: y, month: m });
  };
  const tab = (active) => `px-3 py-1.5 rounded-md text-sm transition-colors ${active ? "bg-amber-500/15 text-amber-300" : "text-slate-400 hover:text-slate-200"}`;
  return (
    <div data-testid={`${testPrefix}-picker`} className="flex flex-wrap items-center gap-2">
      <div className="flex items-center bg-[#1A2335] border border-[#222D42] rounded-lg p-0.5">
        <button data-testid={`${testPrefix}-mode-month`} onClick={() => setPeriod({ ...period, month: period.month || new Date().getMonth() + 1 })} className={tab(isMonth)}>Mese</button>
        <button data-testid={`${testPrefix}-mode-year`} onClick={() => setPeriod({ ...period, month: null })} className={tab(!isMonth)}>Anno</button>
      </div>
      <div className="flex items-center bg-[#1A2335] border border-[#222D42] rounded-lg">
        <button data-testid={`${testPrefix}-prev`} onClick={() => shift(-1)} className="p-2 text-slate-400 hover:text-amber-300"><ChevronLeft className="w-4 h-4" /></button>
        <span data-testid={`${testPrefix}-label`} className="font-mono text-sm text-slate-100 min-w-[96px] text-center">{isMonth ? `${MESI[period.month - 1]} ${period.year}` : period.year}</span>
        <button data-testid={`${testPrefix}-next`} onClick={() => shift(1)} className="p-2 text-slate-400 hover:text-amber-300"><ChevronRight className="w-4 h-4" /></button>
      </div>
    </div>
  );
};
